import * as React from 'react';
import {cn} from 'src/lib/utils';

type Props = Omit<React.ComponentProps<'input'>, 'onChange'> & {
  onChange?: (value: string) => void;
  selectOnFocus?: boolean;
};

export const TextInput = React.forwardRef(
  (props: Props, ref: React.Ref<HTMLInputElement>) => {
    const {onChange, className, selectOnFocus, ...otherProps} = props;
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange?.(e.target.value);
    };
    const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
      if (selectOnFocus) {
        e.target.select();
      }
      props.onFocus?.(e);
    };
    return (
      <input
        ref={ref}
        {...otherProps}
        onFocus={handleFocus}
        onChange={handleChange}
        className={cn(
          'placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 shadow-xs transition-[color,box-shadow] outline-none disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
          'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
          'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
          className,
        )}
      />
    );
  },
);
